import { FolderPlus as FolderLink } from 'lucide-react';

export function ChatTopHeader({ projectAssigned, onLinkProject }) {
    if (projectAssigned) return null;

    return (
        <div className="w-full bg-gradient-to-r from-blue-950 via-blue-900/80 to-blue-950 border-b border-blue-700/50 backdrop-blur-sm">
            <div className="mx-auto px-4 py-3 flex items-center justify-between gap-3">
                <div className="flex items-center gap-2.5 min-w-0">
                    <div className="flex items-center justify-center w-7 h-7 rounded-full bg-blue-500/20 border border-blue-400/30 shrink-0">
                        <FolderLink size={14} className="text-blue-300" />
                    </div>
                    <div className="min-w-0">
                        <span className="text-blue-100 text-sm font-semibold">Unassigned Chat</span>
                        <span className="hidden sm:inline text-blue-300/80 text-sm ml-1.5">— Link this chat to a project to start working on permits</span>
                    </div>
                </div>

                <button
                    onClick={onLinkProject}
                    className="shrink-0 px-3.5 py-1.5 rounded-full text-xs font-semibold bg-blue-600 text-white hover:bg-blue-400 active:bg-blue-600 transition-colors shadow-sm shadow-blue-900/50"
                >
                    Link to Project
                </button>
            </div>
        </div>
    );
}
